export default __webpack_public_path__ + "static/logo-2-661c001ba3f43b92eb2a3505af8b668a.svg";